import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import { Form } from 'react-form';
import { Card, CardText } from 'material-ui';
import _ from 'lodash';
import Translate from 'translate';
import Table from 'components/HTMLElements/Table/Custom';
import IncmsService from 'services/IncmsService';
import { Text } from 'components/FormElements/';
import { toggleLoading } from 'stores/actions/';

class AssignFileModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      submitted: false
    };

    this.submitForm = this.submitForm.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.open && !this.props.open) {
      this.setState({ data: [], submitted: false });
    }
  }

  submitForm(data) {
    this.props.toggleLoading(true);

    let filterParams = {};
    _.map(data, (value, filter) => {
      if (value) filterParams[`filters[${filter}]`] = value;
    });

    IncmsService.searchProfile(filterParams).then(response => {
      if (response.data)
        this.setState({ data: response.data, submitted: true });
      else this.setState({ submitted: true });
      this.props.toggleLoading(false);
    });
  }

  render() {
    const { onSelectCard, onClose, open } = this.props;

    return (
      <Modal
        closeOnEsc={false}
        little
        modalClassName="modal-search-incms col-md-8"
        open={open}
        onClose={() => {
          this.setState({ data: [] });
          onClose();
        }}
      >
        <h5 className="mt-0">
          <Translate id="assignAccount.fileAccount" />
        </h5>

        <Form onSubmit={this.submitForm}>
          {({ getValue, submitForm }) => (
            <form onSubmit={submitForm} className="mt-4">
              <div className="row mb-3">
                <div className="col-md-6">
                  <Text
                    field="account"
                    type="file"
                    placeholder="incmsAccountReference"
                    className="form-control"
                  />
                </div>
              </div>
              <div className="text-right">
                <button className="btn btn-info">
                  <Translate id="assignAccount.buttonadd" />
                </button>
              </div>
              <hr />
            </form>
          )}
        </Form>
        <div className="box-body">
          <Table
            className="app-table-white"
            style={{ width: '100%' }}
            // data={data}
            columns={[
              {
                Header: <Translate id="assignAccount.fileName" />,
                accessor: ''
              },
              {
                Header: <Translate id="assignAccount.comments" />,
                accessor: ''
              },
              {
                Header: <Translate id="assignAccount.createDate" />,
                accessor: ''
              }
            ]}
          />
        </div>

        <div className="row content mt-3">
          {_.map(this.state.data, (item, index) => (
            <div key={index} className="col-md-6 mt-1 mb-3">
              <Card
                containerStyle={{ cursor: 'pointer' }}
                onClick={() => {
                  onClose();
                  onSelectCard(item);
                }}
              >
                <CardText>
                  <div className="col-md-12 p-0">
                    <div className="row">
                      <div className="col-md-3">
                        <Translate id="name" />
                      </div>
                    </div>
                  </div>
                </CardText>
              </Card>
            </div>
          ))}

          {this.state.submitted && !this.state.data.length && (
            <div className="col-md-12 text-center">
              <h4 className="text-muted mt-0">
                <Translate id="noDataFound" />
              </h4>
            </div>
          )}
        </div>
      </Modal>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  toggleLoading: isLoading => {
    dispatch(toggleLoading(isLoading));
  }
});

module.exports = connect(null, mapDispatchToProps)(AssignFileModal);



// WEBPACK FOOTER //
// ./routes/app/components/Agent/AssignFileModal/index.js